module.exports = __webpack_public_path__ + "static/media/event-3.dd516448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/event-3.jpg
// module id = 549
// module chunks = 0